import { emptyFromToFilter, emptyVehicleWarningFilter } from "@/constants";
import { HistoryFilterType } from "./types";

export const emptyHistoryFilter: HistoryFilterType = 
{
    vehiclesWarnings: { ...emptyVehicleWarningFilter },
    vehiclesOver35TMode: false,
    categories: [],
    dates: { ...emptyFromToFilter },
    overweightLimit: { ...emptyFromToFilter },
    axelsCounts: { ...emptyFromToFilter },
    axleOverweight: { ...emptyFromToFilter },
    above35LastDayPlateNumber: '',
    vehicleRecordsRequest: {
      metricLocalizationUid: '',
      metricPointsUIds: []
    },
    paging: {
      pageNo: 1,
      pageSize: 10,
    }
};